import React from "react";
import Classes from "./styles/style.module.css";
import CustomInput from "../../assets/components/customInput";
import CustomButton from "../../assets/components/CustomButton";
import CustomSelect from "../../assets/components/CustomSelect";
import CustomCheckBox from "../../assets/components/CustomCheckBox";
import { motion } from "framer-motion";

const animations = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};

const RegisterFirstStep = ({
  personalCode,
  name,
  familyName,
  relation,
  setpersonalCode,
  setname,
  setFamilyName,
  setrelation,
  handleChageStep,
}) => {
  return (
    <motion.div
      variants={animations}
      initial={animations.initial}
      animate={animations.animate}
      exit={animations.exit}
      className={Classes.loginContent}
    >
      <h3>حساب کاربری جدید ایجاد کنید.</h3>
      <h5 className="text-center">اطلاعات خود را وارد کنید.</h5>
      <CustomInput
        label={"نام"}
        placeholder={"نام خود را وارد کنید"}
        value={name}
        handleChange={(value) => setname(value)}
        name="name"
      />
      <CustomInput
        label={"نام خانوادگی"}
        placeholder={"نام خانوادگی خود را وارد کنید"}
        value={familyName}
        handleChange={(value) => setFamilyName(value)}
        name="familyName"
      />
      <CustomInput
        label={"کد پرسنلی"}
        value={personalCode}
        placeholder={"کد پرسنلی خود را وارد کنید"}
        handleChange={(value) => {}}
        name={"personalCode"}
        disabled
      />
      <CustomSelect
        label={"نسبت"}
        handleChange={(value) => {}}
        value={relation}
        options={["کارمند فولاد", "همسر", "فرزند دختر", "فرزند پسر"]}
        name={"relation"}
        placeHolder={"نسبت"}
        disabled
      />
      <div className={Classes.checkBoxContainer}>
        <div className="mt-3">
          <CustomCheckBox
            val={true}
            handleChange={() => {
              return;
            }}
            disabled={true}
            label={"قوانین و مقررات را میپذیرم"}
          />
        </div>
      </div>
      <CustomButton
        text={"مرحله بعدی"}
        color={"primary"}
        clickHandler={handleChageStep}
        styles={{ marginTop: "20px" }}
      />
    </motion.div>
  );
};

export default RegisterFirstStep;
